"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosApiClient = void 0;
const tslib_1 = require("tslib");
const utils_1 = require("@smallstack/utils");
const axios_1 = tslib_1.__importDefault(require("axios"));
const generated_1 = require("./generated");
class AxiosApiClient {
    constructor(apiClientConfiguration) {
        this.apiClientConfiguration = apiClientConfiguration;
    }
    /**
     * Loads all pages of an endpoint. Please provide a function that returns a @smallstack/core-common/Page
     */
    static loadAllPages(apiCallFn) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let page = 1;
            let responsePage;
            const models = [];
            do {
                responsePage = yield apiCallFn(page);
                models.push(...responsePage.elements);
                page++;
            } while (responsePage.hasNext);
            return models;
        });
    }
    /**
     * Returns a new AxiosApiClient with an overwritten token. All other configuration options stay the same
     * @param token a jwt, access or service token
     */
    withToken(token) {
        return new AxiosApiClient(Object.assign(Object.assign({}, this.apiClientConfiguration), { token }));
    }
    /** Returns a new AxiosApiClient with an extended configuration. */
    withConfiguration(extendedConfiguration) {
        return new AxiosApiClient(Object.assign(Object.assign({}, this.apiClientConfiguration), extendedConfiguration));
    }
    /** Returns a new AxiosApiClient with an extended configuration based on a models meta data. */
    withConfigFromMeta(model) {
        var _a;
        const newConfig = {};
        if ((_a = model === null || model === void 0 ? void 0 : model._meta) === null || _a === void 0 ? void 0 : _a.resellerId)
            newConfig.resellerId = model._meta.resellerId;
        if (model._meta.tenantId)
            newConfig.tenantId = model._meta.tenantId;
        return new AxiosApiClient(Object.assign(Object.assign({}, this.apiClientConfiguration), newConfig));
    }
    get(Api, axiosInstance) {
        const configuration = new generated_1.Configuration({ basePath: this.apiClientConfiguration.apiUrl });
        const client = axiosInstance === undefined
            ? axios_1.default.create(Object.assign(Object.assign({}, this.apiClientConfiguration.axiosConfig), { baseURL: this.apiClientConfiguration.apiUrl }))
            : axiosInstance;
        if (client.defaults.baseURL === undefined)
            client.defaults.baseURL = this.apiClientConfiguration.apiUrl;
        client.interceptors.request.use((config) => {
            if (this.apiClientConfiguration.tenantId)
                config.headers["x-tenant-id"] = (0, utils_1.getValueFromStringProviderSync)(this.apiClientConfiguration.tenantId);
            if (this.apiClientConfiguration.authTenantId)
                config.headers["x-auth-tenant-id"] = (0, utils_1.getValueFromStringProviderSync)(this.apiClientConfiguration.authTenantId);
            if (this.apiClientConfiguration.resellerId)
                config.headers["x-reseller-id"] = (0, utils_1.getValueFromStringProviderSync)(this.apiClientConfiguration.resellerId);
            if (this.apiClientConfiguration.token)
                config.headers["Authorization"] =
                    "Bearer " + (0, utils_1.getValueFromStringProviderSync)(this.apiClientConfiguration.token);
            // filter null and undefined
            for (const key in config.headers)
                if (config.headers[key] === undefined || config.headers[key] === null)
                    delete config.headers[key];
            return config;
        }, (error) => {
            return Promise.reject(error);
        });
        return new Api(configuration, configuration.basePath, client);
    }
}
exports.AxiosApiClient = AxiosApiClient;
